import React, { useState } from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import SpanText from 'components/atoms/SpanText/SpanText';
import SmallIcon from 'components/atoms/SmallIcon/SmallIcon';
import homeIcon from 'assets/images/svg/homeIcon.svg';
import phoneIcon from 'assets/images/svg/phoneIcon.svg';
import emailIcon from 'assets/images/svg/emailIcon.svg';
import PrivacyPolicyModal from 'components/molecules/PrivacyPolicyModal/PrivacyPolicyModal';

const StyledFooterWrapper = styled.div`
  margin: auto;
  max-width: 100%;
  margin-top: 20px;
  height: auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  letter-spacing: 3px;
  background-color: ${({ theme }) => theme.white};
  ${({ theme }) => theme.mqx.bigTablet} {
    flex-wrap: wrap;
    margin-top: 0;
  }
`;

const StyledInnerWrapper = styled.div`
  display: grid;
  grid-template-rows: 40% auto;
  justify-items: center;
  align-items: center;
  height: 90px;
  width: 280px;
  text-decoration: none;
  border-bottom: 2px solid ${({ theme }) => theme.primary};
  cursor: pointer;

  ${({ theme }) => theme.mqx.bigTablet} {
    margin-top: 20px;
  }
`;

const StyledSpanText = styled(SpanText)`
  font-size: 1.4rem;
`;

const StyledLink = styled.a`
  color: ${({ theme }) => theme.black};
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
  text-transform: uppercase;
  border: 2px solid ${({ theme }) => theme.primary};
  padding: 5px;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const StyledDownloadLink = styled(StyledLink)``;

const StyledPrivacyLink = styled(StyledLink)`
  cursor: pointer;
  background: none;
`;

const LinksWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;

  ${({ theme }) => theme.mqx.tablet} {
    justify-content: center;
    gap: 10px;
    padding: 0 10px;
    flex-direction: column;
  }
`;

const TheLastWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  text-align: center;
`;

const Footer = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  const data = useStaticQuery(graphql`
    {
      datoCmsContact {
        street
        city
        phonehref
        phone
        emailhref
        email
        name
      }
    }
  `);

  const { street, city, phoneHref, phone, emailHref, email, name } = data.datoCmsContact;
  const mapsHref = `https://www.google.com/maps?q=${encodeURIComponent(`${street} ${city}`)}`;
  const telHref = phoneHref?.startsWith('tel:') ? phoneHref : `tel:${phoneHref || phone}`;
  const mailHref = emailHref?.startsWith('mailto:') ? emailHref : `mailto:${emailHref || email}`;

  return (
    <>
      <StyledFooterWrapper>
        <StyledInnerWrapper as="a" href={mapsHref} target="_blank" rel="noopener noreferrer">
          <SmallIcon icon={homeIcon} />
          <SpanText>
            {street}
            <br />
            {city}
          </SpanText>
        </StyledInnerWrapper>

        <StyledInnerWrapper as="a" href={telHref}>
          <SmallIcon icon={phoneIcon} />
          <SpanText>{phone}</SpanText>
        </StyledInnerWrapper>

        <StyledInnerWrapper as="a" href={mailHref}>
          <SmallIcon icon={emailIcon} />
          <SpanText>{email}</SpanText>
        </StyledInnerWrapper>
      </StyledFooterWrapper>
      <LinksWrapper>
        <StyledPrivacyLink as="button" onClick={() => setIsPrivacyModalOpen(true)}>
          Polityka prywatności
        </StyledPrivacyLink>
        <StyledDownloadLink
          href="/standardy-ochrony-maloletnich.pdf"
          download="standardy-ochrony-maloletnich.pdf"
          target="_blank"
          rel="noopener noreferrer"
          type="application/pdf"
        >
          Standardy ochrony małoletnich
        </StyledDownloadLink>
      </LinksWrapper>
      <TheLastWrapper>
        <StyledSpanText>
          &copy; {new Date().getFullYear()} {name}
        </StyledSpanText>
      </TheLastWrapper>
      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />
    </>
  );
};

export default Footer;
